import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-transferencia',
  templateUrl: './transferencia.component.html',
  styleUrls: ['./transferencia.component.css']
})
export class TransferenciaComponent implements OnInit {

  constructor(public modalCtrl: ModalController) { }

  ngOnInit(): void {
  }

  closeModal() { 
    this.modalCtrl.dismiss()
  }

}
